import { render, staticRenderFns } from "./GiftProduct.vue?vue&type=template&id=e0b45b34&scoped=true&lang=pug&"
import script from "./GiftProduct.vue?vue&type=script&lang=js&"
export * from "./GiftProduct.vue?vue&type=script&lang=js&"
import style0 from "./GiftProduct.vue?vue&type=style&index=0&id=e0b45b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b45b34",
  null
  
)

export default component.exports